import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from '../../components/icons';

export function PrivacyPageTR() {
  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/tr"
          className="inline-flex items-center gap-2 text-chocolate-600 hover:text-sage-600 mb-8 transition-colors font-medium"
        >
          <ArrowLeft className="w-4 h-4" />
          Ana Sayfaya Don
        </Link>

        <div className="freud-card-elevated p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 bg-sage-100 rounded-xl">
              <Shield className="w-6 h-6 text-sage-600" />
            </div>
            <h1 className="freud-heading-2xl text-chocolate-900">Gizlilik Politikasi</h1>
          </div>

          <div className="prose prose-chocolate max-w-none">
            <p className="freud-text-base text-chocolate-500 mb-6">
              Son guncelleme: {new Date().toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">1. Topladikimiz Bilgiler</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              Dogrudan bize sagladiginiz bilgileri topluyoruz, bunlar arasinda:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Hesap bilgileri (ad, e-posta adresi)</li>
              <li>Degerlendirme yanitlari ve sonuclari</li>
              <li>Iletisim tercihleri</li>
              <li>Saglamayi tercih ettiginiz diger bilgiler</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">2. Bilgilerinizi Nasil Kullaniyoruz</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              Topladikimiz bilgileri su amaclarla kullaniyoruz:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Hizmetlerimizi sunmak, surdurmek ve iyilestirmek</li>
              <li>Degerlendirmelerinizi islemek ve tamamlamak</li>
              <li>Kisisellestirilmis icgoruler ve oneriler olusturmak</li>
              <li>Hizmetlerimiz hakkinda sizinle iletisim kurmak</li>
              <li>Dolandiricilik veya yasa disi faaliyetlere karsi koruma saglamak</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">3. Bilgi Paylasimi</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Kisisel bilgilerinizi ucuncu taraflara satmiyoruz, takas etmiyoruz veya kiralamiyoruz. Bilgilerinizi asagidaki taraflarla paylasabiliriz:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Atanan kociniz veya partner kurulusunuz</li>
              <li>Operasyonlarimiza yardimci olan hizmet saglayicilar</li>
              <li>Yasa geregi veya haklarimizi korumak icin gerekli oldugunda</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">4. Veri Guvenligi</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Kisisel bilgilerinizi yetkisiz erisim, degistirme, ifsa veya imhaya karsi korumak icin uygun teknik ve organizasyonel onlemler uyguluyoruz.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">5. Haklariniz</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              Asagidaki haklara sahipsiniz:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Kisisel bilgilerinize erismek</li>
              <li>Yanlis verileri duzeltmek</li>
              <li>Verilerinizin silinmesini talep etmek</li>
              <li>Verilerinizin islenmesine itiraz etmek</li>
              <li>Verilerinizi tasinabilir bir formatta disa aktarmak</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">6. Cerezler</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Deneyiminizi gelistirmek, kullanimi analiz etmek ve pazarlama calismalarina yardimci olmak icin cerezler ve benzer teknolojiler kullaniyoruz. Cerezleri tarayici ayarlariniz uzerinden kontrol edebilirsiniz.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">7. Iletisim</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              Bu Gizlilik Politikasi hakkinda sorulariniz varsa, lutfen support@mail.humanpotentialos.com adresinden bizimle iletisime gecin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
